const playStreamioAudio = (element: HTMLDivElement) => {
  element.classList.add("audio-block__audio--load-audio");
  const iframe = element.querySelector("iframe");
  
  if (!!iframe) {
    const iframeSrcValue = iframe.getAttribute("src");

    iframe.setAttribute("onload", "iframeAudioLoadedHandler(this);");
    if (iframeSrcValue && !iframeSrcValue.includes("autoplay=true")) {
      const url = new URL(iframeSrcValue, window.location.origin);
      url.searchParams.set("autoplay", "true");
      iframe.setAttribute("src", url.toString());
    }
  }
};

const initializeStreamioAudio = () => {
  const streamioPlayers = document.querySelectorAll(".audio-block__audio--streamio");
  if (streamioPlayers.length === 0) {
    return;
  }

  streamioPlayers.forEach((element) => {
    const playButton = element.querySelector(".audio-block__play-button") as HTMLButtonElement;
    
    if (!playButton) {
      return;
    }
    
    playButton.addEventListener("click", (e) => {
      e.stopPropagation();
      playStreamioAudio(element as HTMLDivElement);
    }, { once: true });
    
    element.addEventListener("click", (e) => {
      e.stopPropagation();
      playStreamioAudio(element as HTMLDivElement);
    }, { once: true });
  });
};

window.iframeAudioLoadedHandler = (iframeElement: HTMLIFrameElement) => {
  const element = iframeElement.closest(".audio-block__audio--streamio") as HTMLElement;
  element?.classList.add("audio-block__audio--play-audio");
  element?.classList.remove("audio-block__audio--load-audio");
};

const initializeAudioFile = () => {
  const audioFilePlayers = document.querySelectorAll(".audio-block__audio--audio-file");

  if (audioFilePlayers.length === 0) return;

  audioFilePlayers.forEach((element) => {
    const playButton = element.querySelector(".audio-block__play-button") as HTMLButtonElement;

    if (!playButton) return;

    const toggleHandler = (e: Event) => {
      e.stopPropagation();
      toggleAudioFile(element as HTMLDivElement);
    };

    playButton.addEventListener("click", toggleHandler);
    element.addEventListener("click", toggleHandler);
  });
};

const toggleAudioFile = (element: HTMLDivElement) => {
  const audioElement = element.querySelector("audio") as HTMLAudioElement;

  if (!audioElement) return;

  if (audioElement.paused) {
    element.classList.add("audio-block__audio--play-audio");
    audioElement.play();
  } else {
    audioElement.pause();
  }
};

const init = () => {
  initializeStreamioAudio();
  initializeAudioFile();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}